/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSysConfig.vue?vue&type=template&id=b17c9698&scoped=true"
import script from "./popSysConfig.vue?vue&type=script&lang=js"
export * from "./popSysConfig.vue?vue&type=script&lang=js"
import style0 from "./popSysConfig.vue?vue&type=style&index=0&id=b17c9698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17c9698",
  null
  
)

export default component.exports